import { IconeProprio, type PropsIcone } from './base'

/**
 * Ícone próprio de estrutura veicular / anatomia (Body-in-White / monobloco).
 *
 * Representa a gaiola estrutural de sobrevivência do automóvel sem os painéis
 * externos de fechamento: longarina do teto, Colunas A, B e C, soleira/caixa
 * de ar com arcos de roda estruturais, longarinas e vãos de porta abertos.
 */
export function IconeAnatomia(props: PropsIcone) {
  return (
    <IconeProprio {...props}>
      {/* Longarina superior do teto */}
      <path d="M6.5 5.5h11" />
      {/* Coluna A (pilar dianteiro inclinado) */}
      <path d="M6.5 5.5L3.5 12" />
      {/* Coluna B (pilar central de contenção) */}
      <path d="M12 5.5v12.5" />
      {/* Coluna C (pilar traseiro) */}
      <path d="M17.5 5.5L20.5 12" />
      {/* Soleira inferior (caixa de ar) com arcos de roda estruturais recortados */}
      <path d="M1.5 18h2a2.5 2.5 0 0 1 5 0h7a2.5 2.5 0 0 1 5 0h2" />
      {/* Estrutura frontal: longarina e crash box do cofre do motor */}
      <path d="M3.5 12H1.5v6" />
      {/* Estrutura traseira: longarina do porta-malas */}
      <path d="M20.5 12h2v6" />
      {/* Travessas de reforço da linha de cintura */}
      <path d="M3.5 12h2.5M18 12h2.5" />
      {/* Nó estrutural de amarração do teto */}
      <path d="M11 5.5h2" />
    </IconeProprio>
  )
}

/** Sinônimo estrutural do monobloco. */
export const IconeEstruturaMonobloco = IconeAnatomia

/** Compatibilidade com o registro de módulos. */
export const IconeModuloEstrutura = IconeAnatomia
